import { useLocation } from 'react-router';

export default function useQuerySearch() {
  return new URLSearchParams(useLocation().search);
}
